export default {
      id: "arrowForward-usage",
      viewBox: "0 0 15 10",
      url: __webpack_public_path__ + "sprite.1792148661250.svg#arrowForward-usage",
      toString: function () {
        return this.url;
      }
    }